module.exports = __webpack_public_path__ + "static/media/industry_icon2.ef2df757.svg";